
import LpInput from "@/app/ui/components/lp-input/index.vue";
import { Options, Vue, prop } from "vue-class-component";
import { PusatResolusiV2Controller } from "@/app/ui/controllers/PusatResolusiV2Controller";
import { SubmitFeedbackApiRequest } from "@/data/payload/api/PusatResolusiV2ApiRequest";
import { MainAppController } from "@/app/ui/controllers/MainAppController";

enum ReviewType {
  GOOD = "good",
  NEUTRAL = "neutral",
  BAD = "bad",
  EMPTY = ""
}

class Props {
  modelValue = prop<boolean>({
    type: Boolean,
    default: false
  });
  reviewType = prop<string>({
    default: ReviewType.EMPTY,
    type: String,
    validator: (value: string) => {
      return Object.values(ReviewType).includes(value as ReviewType);
    }
  });
  ticketId = prop<number>({
    default: 0,
    type: Number,
    required: true
  });
  ticketNo = prop<string>({
    default: "-",
    type: String,
    required: true
  });
}

@Options({
  emits: ["update:modelValue", "close", "success"],
  components: { LpInput }
})
export default class ModalTicketReview extends Vue.with(Props) {
  feedback = "";
  selectedType = ReviewType.EMPTY;

  selectRating(type: ReviewType) {
    this.selectedType = type;
  }

  mounted() {
    if (this.reviewType !== ReviewType.EMPTY) {
      this.selectedType = this.reviewType as ReviewType;
    }
  }

  set openDialog(value: boolean) {
    this.$emit("update:modelValue", value);
  }

  get openDialog() {
    return this.modelValue;
  }

  cancelPopup() {
    this.resetForm();
    this.$emit("close");
    this.$emit("update:modelValue");
  }

  async onSubmit() {
    try {
      MainAppController.showLoading();
      const send = await PusatResolusiV2Controller.submitFeedback({
        id: this.ticketId,
        payload: new SubmitFeedbackApiRequest({
          reviewType: this.selectedType,
          reviewMessage: this.feedback
        })
      });
      if (send) {
        this.resetForm();
        this.$toast.add({
          severity: "success",
          detail: `${this.$t('pusatResolusi.ulasanToast')} ${this.ticketNo}</b> ${this.$t('pusatResolusi.successSaved')}`,
          life: 10000,
          closable: false,
          icon: "success-status"
        });
        this.$emit("success");
      }
    } catch (error) {
      this.$toast.add({
        severity: "error",
        detail: `${this.$t('pusatResolusi.ulasanToast')} ${this.ticketNo}</b> ${this.$t('pusatResolusi.failedSaved')}`,
        life: 5000,
        closable: false,
        editable: false
      });
    } finally {
      MainAppController.closeLoading();
    }
  }

  resetForm() {
    this.feedback = "";
    this.selectedType = ReviewType.EMPTY;
  }

  get disabledSubmitButton() {
    return this.selectedType === ReviewType.EMPTY;
  }
}
